import 'firebase/auth';
import 'firebase/database';

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const config = {
  apiKey: 'AIzaSyCASJZ_PdqXLDaA-L6-7b7xt3QScBhido0',
  appId: '1:631227739849:web:692913f79033c0327ba718',
  authDomain: 'englishstar-sk-portal.firebaseapp.com',
  databaseURL:
    'https://englishstar-sk-portal-default-rtdb.europe-west1.firebasedatabase.app',
  measurementId: 'G-SCPWLD2RRD',
  messagingSenderId: '631227739849',
  projectId: 'englishstar-sk-portal',
  storageBucket: 'englishstar-sk-portal.firebasestorage.app',
};

initializeApp(config);

export const auth = getAuth();
export const database = getDatabase();
